import React from "react";
import { Route } from "react-router-dom";
import UzmartDoc from "../views/Single-Uzmart-doc";
import UzmartIntroduction from "../views/Single-Uzmart-doc/Introduction";
import UzmartBasic from "../views/Single-Uzmart-doc/Basic";
import UzmartServer from "../views/Single-Uzmart-doc/Server";
import UzmartFront from "../views/Single-Uzmart-doc/front";
import UzmartAdmin from "../views/Single-Uzmart-doc/admin";
import Recommendations from "../views/Foodyman-doc/recommendations";
import UzmartLocalFront from "../views/Single-Uzmart-doc/local-front";
import UzmartMobileApp from "../views/Single-Uzmart-doc/Mobile-app";
import UzmartFlutterSDK from "../views/Single-Uzmart-doc/Flutter-SDK";
import UzmartLocalServer from "../views/Single-Uzmart-doc/Local-server";
import UzmartInstallOnServer from "../views/Single-Uzmart-doc/Install-on-server";
import UzmartMandatorySetup from "../views/Single-Uzmart-doc/Mandatory-setup";
import UzmartCustomization from "../views/Single-Uzmart-doc/Customization";
import UzmartMandatorySetupMobile from "../views/Single-Uzmart-doc/Mandatory-setup-mobile";
import UzmartMandatorySetupBackend from "../views/Single-Uzmart-doc/Mandatory-setup-backend";
import PaymentInstallation from "../views/Single-Uzmart-doc/Payment-Installation";
import UzmartImageSettings from "../views/Single-Uzmart-doc/image-settings";
import UzmartMandatorySetupVendor from "../views/Single-Uzmart-doc/Moderator-setup-vendor";
import UzmartMandatorySetupCustomer from "../views/Single-Uzmart-doc/Moderator-setup-customer";
import UzmartMandatorySetupPos from "../views/Single-Uzmart-doc/Moderator-setup-pos";
import UzmartMandatorySetupDeliveryboy from "../views/Single-Uzmart-doc/Moderator-setup-deliveryboy";
import UzmartCustomizationMobile from "../views/Single-Uzmart-doc/Customization-mobile";
import CustomizationMobileDelivery from "../views/Foodyman-doc/Customization-mobile-delivery";
import UzmartCustomizationMobileCustomer from "../views/Single-Uzmart-doc/Customization-mobile-customer";
import CustomizationMobilePos from "../views/Foodyman-doc/Customization-mobile-pos";
import AppBuildReleaseCustomer from "../views/Foodyman-doc/App-build-release-customer";
import AppBuildReleasePos from "../views/Foodyman-doc/App-build-release-pos";
import AppBuildReleaseVendor from "../views/Foodyman-doc/App-build-release-vendor";
import AppBuildReleaseDelivery from "../views/Foodyman-doc/App-build-release-deliveryboy";
import UzmartMandatorySetupWeb from "../views/Single-Uzmart-doc/Mandatory-setup-web";
import UzmartBuildCodeAndSetupOnServer from "../views/Single-Uzmart-doc/Build-code-and-setup-on-server";
import UzmartBuildCodeAndSetupOnServerBackend from "../views/Single-Uzmart-doc/Build-code-and-setup-on-server-backend";
import UzmartUpdateAdminPanel from "../views/Single-Uzmart-doc/Update-admin-panel";
import UzmartUpdateAppWeb from "../views/Single-Uzmart-doc/Update-app-web";
import UzmartSupportPlan from "../views/Single-Uzmart-doc/supportPlan";
import UzmartFirebaseSetup from "../views/Single-Uzmart-doc/firebase-setup";
import TroubleshootingBackend from "../views/Foodyman-doc/Troubleshooting-backend";
import TroubleshootingAdmin from "../views/Foodyman-doc/Troubleshooting-admin";
import UpdateFooyman from "../views/Foodyman-doc/update";
import MobileVendor from "../views/Uzmart-doc/Mobile-Vendor";
import Videos from "../views/Single-Uzmart-doc/videos";

const SingleUzmart = () => {
  return (
      <Route path="/uzmart-single-documentation" element={<UzmartDoc />}>
              <Route
                  path="/uzmart-single-documentation/introduction"
                  element={<UzmartIntroduction />}
              />
              <Route
                  path="/uzmart-single-documentation/installation-video"
                  element={<Videos />}
              />
              <Route
                  path="/uzmart-single-documentation/basic"
                  element={<UzmartBasic />}
              />
              <Route
                  path="/uzmart-single-documentation/server"
                  element={<UzmartServer />}
              />
              <Route
                  path="/uzmart-single-documentation/front"
                  element={<UzmartFront />}
              />
              <Route
                  path="/uzmart-single-documentation/admin"
                  element={<UzmartAdmin />}
              />
              <Route
                  path="/uzmart-single-documentation/recommendations"
                  element={<Recommendations />}
              />
              <Route
                  path="/uzmart-single-documentation/local-front"
                  element={<UzmartLocalFront />}
              />
              <Route
                  path="/uzmart-single-documentation/mobile-app"
                  element={<UzmartMobileApp />}
              />
              <Route
                  path="/uzmart-single-documentation/vendor-app"
                  element={<MobileVendor />}
              />
              <Route
                  path="/uzmart-single-documentation/driver-app"
                  element={<MobileVendor />}
              />
              <Route
                  path="/uzmart-single-documentation/pos-app"
                  element={<MobileVendor />}
              />
              <Route
                  path="/uzmart-single-documentation/flutter-sdk"
                  element={<UzmartFlutterSDK />}
              />
              <Route
                  path="/uzmart-single-documentation/local-server"
                  element={<UzmartLocalServer />}
              />
              <Route
                  path="/uzmart-single-documentation/install-on-server"
                  element={<UzmartInstallOnServer />}
              />
              <Route
                  path="/uzmart-single-documentation/mandatory-setup"
                  element={<UzmartMandatorySetup />}
              />
              <Route
                  path="/uzmart-single-documentation/customization"
                  element={<UzmartCustomization />}
              />
              <Route
                  path="/uzmart-single-documentation/mandatory-setup-mobile"
                  element={<UzmartMandatorySetupMobile />}
              />
              <Route
                  path="/uzmart-single-documentation/mandatory-setup-backend"
                  element={<UzmartMandatorySetupBackend />}
              />
              <Route
                  path="/uzmart-single-documentation/payment-installation"
                  element={<PaymentInstallation />}
              />
              <Route
                  path="/uzmart-single-documentation/image-settings"
                  element={<UzmartImageSettings />}
              />
              <Route
                  path="/uzmart-single-documentation/mandatory-setup-vendor"
                  element={<UzmartMandatorySetupVendor />}
              />
              <Route
                  path="/uzmart-single-documentation/mandatory-setup-customer"
                  element={<UzmartMandatorySetupCustomer />}
              />
              <Route
                  path="/uzmart-single-documentation/mandatory-setup-pos"
                  element={<UzmartMandatorySetupPos />}
              />
              <Route
                  path="/uzmart-single-documentation/mandatory-setup-deliveryboy"
                  element={<UzmartMandatorySetupDeliveryboy />}
              />
              <Route
                  path="/uzmart-single-documentation/customization-vendor"
                  element={<UzmartCustomizationMobile />}
              />
              <Route
                  path="/uzmart-single-documentation/customization-deliveryboy"
                  element={<CustomizationMobileDelivery />}
              />
              <Route
                  path="/uzmart-single-documentation/customization-customer"
                  element={<UzmartCustomizationMobileCustomer />}
              />
              <Route
                  path="/uzmart-single-documentation/customization-pos"
                  element={<CustomizationMobilePos />}
              />
              <Route
                  path="/uzmart-single-documentation/customer-app-build-release"
                  element={<AppBuildReleaseCustomer />}
              />
              <Route
                  path="/uzmart-single-documentation/pos-app-build-release"
                  element={<AppBuildReleasePos />}
              />
              <Route
                  path="/uzmart-single-documentation/vendor-app-build-release"
                  element={<AppBuildReleaseVendor />}
              />
              <Route
                  path="/uzmart-single-documentation/deliveryboy-app-build-release"
                  element={<AppBuildReleaseDelivery />}
              />
              <Route
                  path="/uzmart-single-documentation/mandatory-setup-web"
                  element={<UzmartMandatorySetupWeb />}
              />
              <Route
                  path="/uzmart-single-documentation/build-code-and-setup-on-server"
                  element={<UzmartBuildCodeAndSetupOnServer />}
              />
              <Route
                  path="/uzmart-single-documentation/build-code-and-setup-on-server-backend"
                  element={<UzmartBuildCodeAndSetupOnServerBackend />}
              />
              <Route
                  path="/uzmart-single-documentation/update-admin-panel"
                  element={<UzmartUpdateAdminPanel />}
              />
              <Route
                  path="/uzmart-single-documentation/update-app-web"
                  element={<UzmartUpdateAppWeb />}
              />
              <Route
                  path="/uzmart-single-documentation/support-plan"
                  element={<UzmartSupportPlan />}
              />
              <Route
                  path="/uzmart-single-documentation/firebase"
                  element={<UzmartFirebaseSetup />}
              />

              <Route
                  path="/uzmart-single-documentation/troubleshooting-backend"
                  element={<TroubleshootingBackend />}
              />
              <Route
                  path="/uzmart-single-documentation/troubleshooting-admin"
                  element={<TroubleshootingAdmin />}
              />
              <Route
                  path="/uzmart-single-documentation/update"
                  element={<UpdateFooyman />}
              />
      </Route>
  );
};

export default SingleUzmart;
